import { PANELS } from '@helpers/constants'
import { trackClosePanelEvent, trackOpenPanelEvent, trackRegisterStudent } from '@helpers/matomo'
import { ON_NAVIGATION } from '@state/actions/appActions'
import {
    OPEN_PANEL,
    OPEN_EXERCISE_PANEL,
    CLOSE_PANEL,
    CLOSE_LAST_PANEL,
    SET_CURRENT_SIDEBAR_WIDTH,
    OPEN_FEEDBACK_PANEL,
    OPEN_PANEL_WITH_DATA,
} from '@state/actions/panelsActions'

/**
 * Initial state
 */
const initialPanelsState = {
    openPanels: [],
    sideBarWidth: undefined,
    exercise: {},
    feedback: { id: undefined, type: undefined },
    panelData: {},
}

/**
 * Reducer
 */
const panelsReducer = (state, action) => {
    switch (action.type) {
        case OPEN_PANEL:
            trackOpenPanelEvent(action.payload)
            return {
                ...state,
                openPanels: [...state.openPanels, action.payload],
            }

        case OPEN_PANEL_WITH_DATA:
            trackOpenPanelEvent(action.payload.panel)
            return {
                ...state,
                openPanels: [...state.openPanels, action.payload.panel],
                panelData: action.payload.data,
            }

        case OPEN_EXERCISE_PANEL:
            trackOpenPanelEvent(action.payload.exercise)
            return {
                ...state,
                openPanels: [...state.openPanels, action.payload.panel],
                exercise: action.payload.exercise,
            }

        case OPEN_FEEDBACK_PANEL:
            trackOpenPanelEvent(PANELS.FEEDBACK)
            return {
                ...state,
                openPanels: [...state.openPanels, PANELS.FEEDBACK],
                feedback: {
                    type: action.payload.type,
                    id: action.payload.id,
                }
            }

        case CLOSE_PANEL:
            if (state.openPanels.includes(action.payload)) {
                trackClosePanelEvent(action.payload)
            }

            return {
                ...state,
                openPanels: state.openPanels.filter(
                    panel => panel !== action.payload
                ),
                panelData: {},
            }

        case CLOSE_LAST_PANEL:
            trackClosePanelEvent(state.openPanels.at(-1))

            if (state.openPanels.at(-1) === PANELS.CREATE_STUDENT) {
                trackRegisterStudent('cancel')
            }

            if (state.openPanels.length > 0) state.openPanels.pop()
            return {
                ...state,
                openPanels: state.openPanels,
            }

        case SET_CURRENT_SIDEBAR_WIDTH:
            return {
                ...state,
                sideBarWidth: action.payload.width,
            }

        case ON_NAVIGATION:
            return {
                ...state,
                openPanels: [],
            }
        default:
            return state
    }
}

export { panelsReducer, initialPanelsState }
